// generated by genversion
export var version = '3.4.5';
//# sourceMappingURL=version.js.map